import script from "./VendorDashboardHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./VendorDashboardHeader.vue?vue&type=script&setup=true&lang=ts"

import "./VendorDashboardHeader.vue?vue&type=style&index=0&id=8f9f038c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f9f038c"]])

export default __exports__